import React from 'react';
import {
  Flex,
  Input,
  FormControl,
  FormLabel,
  useColorModeValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import CreatableDropdown from 'components/CreatableDropDown';

const TableDateFilter = ({
  config = {
    showYear: true,
    showMonth: true,
    showDateRange: true,
  },
  values = {
    year: '',
    month: '',
    fromDate: '',
    toDate: '',
  },
  onChange,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => ({
    label: String(currentYear - i),
    value: String(currentYear - i),
  }));

  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const labelColor = useColorModeValue('gray.600', 'gray.400');
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const handleChange = (field, value) => {
    onChange?.({ ...values, [field]: value });
  };

  return (
    <Flex gap={4} mb={5} wrap="wrap" align="flex-end">
      {/* YEAR */}
      {config.showYear && (
        <FormControl w={{ base: '100%', sm: '130px' }}>
          <FormLabel fontSize="sm" color={labelColor} mb={1}>
            Year
          </FormLabel>
          <CreatableDropdown
            searchCreate={false}
            options={years}
            value={values.year}
            onChange={(val) => handleChange('year', val)}
            placeholder="Year"
            bg={bg}
            borderColor={borderColor}
            isClearable
          />
        </FormControl>
      )}

      {/* MONTH */}
      {config.showMonth && (
        <FormControl w={{ base: '100%', sm: '140px' }}>
          <FormLabel fontSize="sm" color={labelColor} mb={1}>
            Month
          </FormLabel>
          <CreatableDropdown
            searchCreate={false}
            options={months}
            value={values.month}
            onChange={(val) => handleChange('month', val)}
            placeholder="Month"
            bg={bg}
            borderColor={borderColor}
            isClearable
          />
        </FormControl>
      )}

      {/* FROM DATE */}
      {config.showDateRange && (
        <FormControl w={{ base: '100%', sm: '160px' }}>
          <FormLabel fontSize="sm" color={labelColor} mb={1}>
            From Date
          </FormLabel>
          <Input
            type="date"
            value={values.fromDate}
            onChange={(e) => handleChange('fromDate', e.target.value)}
            bg={bg}
            borderColor={borderColor}
            borderRadius="md"
            _hover={{ borderColor: 'blue.400' }}
            _focus={{
              borderColor: 'blue.500',
              boxShadow: '0 0 0 1px #3182ce',
            }}
          />
        </FormControl>
      )}

      {/* TO DATE */}
      {config.showDateRange && (
        <FormControl w={{ base: '100%', sm: '160px' }}>
          <FormLabel fontSize="sm" color={labelColor} mb={1}>
            To Date
          </FormLabel>
          <Input
            type="date"
            min={values.fromDate}
            value={values.toDate}
            onChange={(e) => handleChange('toDate', e.target.value)}
            bg={bg}
            borderColor={borderColor}
            borderRadius="md"
            _hover={{ borderColor: 'blue.400' }}
            _focus={{
              borderColor: 'blue.500',
              boxShadow: '0 0 0 1px #3182ce',
            }}
          />
        </FormControl>
      )}
    </Flex>
  );
};

TableDateFilter.propTypes = {
  config: PropTypes.shape({
    showYear: PropTypes.bool,
    showMonth: PropTypes.bool,
    showDateRange: PropTypes.bool,
  }),
  values: PropTypes.shape({
    year: PropTypes.string,
    month: PropTypes.string,
    fromDate: PropTypes.string,
    toDate: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

export default TableDateFilter;
